/* eslint-disable no-undef */
window.GLOBALS = {
  ASSETS: {
    ...GLOBALS.ASSETS
  },
  API: {
    ...GLOBALS.API
  }
};

if (window.host) {
  __webpack_public_path__ = __webpack_public_path__.replace('airfind.com', window.host);
  window.GLOBALS.ASSETS = replaceHost(window.GLOBALS.ASSETS, window.host);
  window.GLOBALS.API = replaceHost(window.GLOBALS.API, window.host);
}

function replaceHost(obj, host) {
  for (let key in obj) {
    if (typeof obj[key] === "string" && obj[key].includes("airfind.com")) {
      obj[key] = obj[key].replace("airfind.com", host);
    }
  }
  return obj;
}
